
import { defineStore } from 'pinia'
export const useWorkspaceStore = defineStore('wpStore', {
  state: () => ({wpid: null, sat: [], targets: [], time:{}, experiment: {Sat: null,Tar:null,Plan:null}, simulation: null, simulationStep: null,  selectComponent: '', mapShow: true}),
  getters: {
  },
  actions: {
    clear(){
      this.wpid = null
      this.sat = []
      this.targets = []
      this.time = {}
      this.experiment = {Sat: null,Tar:null,Plan:null}
      this.simulation = null
      this.simulationStep = null
      this.selectComponent = ''
      this.mapShow = true
    }
  },
})

